// Resolve which credential + routing params an admin data fetch should use,
// given the current redux state and the selected admin environment.
//
// - Prod (default): today's exact behaviour — the authSlice token, no extra
//   query params, so the request routes to the prod worker unchanged.
// - Staging: the held staging admin token (minted by logging into staging once)
//   plus `env: 'staging'`, which the Pages proxy reads to route to the staging
//   worker and then strips before forwarding (see functions/_lib/workerUrl.js).
//
// `token` may be null in staging when no staging session is held yet — call
// sites MUST gate on that (skip the fetch; the login dialog handles auth) rather
// than firing a request with the wrong/empty credential.
export function adminRequest(state) {
  const env = state.adminEnvSlice.env;
  const token =
    env === "staging" ? state.adminEnvSlice.stagingToken : state.authSlice.token;
  const envParams = env === "staging" ? { env: "staging" } : {};
  return { env, token, envParams };
}
